import { Grid } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";
import { COLORS } from "../../../_globalStore/redux/reducers/Theme/themeConstants";

export const EmployeeNameContainer = styled(Grid)({
  "&:hover": {
    cursor: "pointer",
  },
});

export const MainTableContainer = styled(Grid)(({ theme }) => ({
  "& .highlighted": {
    // border: `2px solid ${theme.palette.error.light} !important`,
    backgroundColor: lighten(COLORS.yellow_gradients.yellow, 0.2),
    borderRadius: "3px",
    maxWidth: "calc(100% - 4px)",
  },

  "& .isWeekend": {
    backgroundColor: lighten(theme.palette.secondary.light, 0.9),
    borderLeft: "1px solid white",
    borderRight: "1px solid white",
  },

  "& .isPublicHoliday": {
    backgroundColor: "pink",
    borderLeft: "1px solid white",
    borderRight: "1px solid white",
  },
}));
